import { AxiosError } from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../../../../../components/Modal';
import {
  backendErrorNotification,
  frontendNotification,
} from '../../../../../../components/Notification';
import HttpStatus from '../../../../../../enums/httpStatus';
import { visitMotiveAPI } from '../../../../../../services/requests';
import { VisitMotive } from '../../../../../../types';

type Props = {
  closeModal: () => void;
  reqCallback: () => void;
  selectedItem: VisitMotive;
};

const ModalDeleteJSX = ({ closeModal, reqCallback, selectedItem }: Props) => {
  const { t } = useTranslation();

  const [waitingResponse, setWaitingResponse] = useState(false);

  const reqDelete = async () => {
    setWaitingResponse(true);

    const source = visitMotiveAPI.axios.CancelToken.source();

    try {
      visitMotiveAPI.query = '';

      const res = await visitMotiveAPI.delete(selectedItem.CodigoMotivo);

      if (res.status === HttpStatus.OK) {
        setWaitingResponse(false);
        frontendNotification({
          message: t('successfullyDeleted'),
          type: 'success',
        });

        reqCallback();
        closeModal();
      } else {
        throw res;
      }
    } catch (err) {
      if (!visitMotiveAPI.axios.isCancel(err)) {
        backendErrorNotification(err as AxiosError<any, any>);
      }
    }

    setWaitingResponse(false);
    return () => {
      source.cancel('Component got unmounted');
    };
  };

  return (
    <Modal
      title={`${t('delete')} ${t('motiveSchedule')}`}
      showModal
      closeModal={closeModal}
      action={() => reqDelete()}
      actionNameBtn={t('delete')}
      isLoading={waitingResponse}
    >
      <div style={{ padding: '1rem' }}>
        {`${t('deleteSure')}?`}
        <p>
          <b>{t('id')}:</b> {selectedItem.CodigoMotivo}
        </p>
        <p>
          <b>{t('motiveFlag')}:</b> {selectedItem.FlagMotivo}
        </p>
        <p>
          <b>{t('description')}:</b> {selectedItem.Descricao}
        </p>
      </div>
    </Modal>
  );
};

export default ModalDeleteJSX;
